<app-page-layout 
  [title]="title"
  [subtitle]="subtitle"
  [heroImage]="heroImage"
  [breadcrumbs]="breadcrumbs"
  [prevPage]="prevPage"
  [nextPage]="nextPage">

  <div class="page-section">
    <h2>L'Assurance RC Pro : Une Protection Essentielle</h2>
    <p>
      L'<strong>assurance Responsabilité Civile Professionnelle</strong> (RC Pro) couvre les dommages causés 
      à des tiers dans le cadre de votre activité professionnelle. Elle est <strong>obligatoire</strong> pour 
      de nombreuses professions réglementées et fortement recommandée pour toutes les autres.
    </p>
  </div>

  <div class="page-section">
    <h3>Pourquoi Souscrire une RC Professionnelle ?</h3>
    <ul>
      <li><strong>Protection juridique</strong> : couverture des frais de défense et d'indemnisation</li>
      <li><strong>Obligation légale</strong> : RC Pro obligatoire pour de nombreuses professions</li>
      <li><strong>Sérénité d'exercice</strong> : travaillez l'esprit tranquille</li>
      <li><strong>Crédibilité professionnelle</strong> : gage de sérieux auprès des clients</li>
      <li><strong>Protection financière</strong> : évitez la ruine en cas de sinistre majeur</li>
    </ul>
  </div>

  <div class="page-section highlight-box">
    <h3>Les Garanties RC Professionnelle</h3>
    <div class="guarantees-grid">
      <div class="guarantee-card">
        <i class="pi pi-exclamation-triangle"></i>
        <h4>Dommages Corporels</h4>
        <p>Blessures causées à des tiers</p>
        <ul>
          <li>Accidents sur chantier</li>
          <li>Blessures en consultation</li>
          <li>Préjudice physique client</li>
        </ul>
      </div>

      <div class="guarantee-card">
        <i class="pi pi-building"></i>
        <h4>Dommages Matériels</h4>
        <p>Détérioration de biens tiers</p>
        <ul>
          <li>Dégâts des eaux</li>
          <li>Incendie</li>
          <li>Casse de matériel</li>
          <li>Destruction de documents</li>
        </ul>
      </div>

      <div class="guarantee-card">
        <i class="pi pi-file"></i>
        <h4>Dommages Immatériels</h4>
        <p>Préjudices financiers indirects</p>
        <ul>
          <li>Erreur de conseil</li>
          <li>Retard de livraison</li>
          <li>Perte d'exploitation client</li>
          <li>Atteinte à la réputation</li>
        </ul>
      </div>

      <div class="guarantee-card">
        <i class="pi pi-shield"></i>
        <h4>Protection Juridique</h4>
        <p>Défense et assistance juridique</p>
        <ul>
          <li>Frais d'avocat</li>
          <li>Frais d'expertise</li>
          <li>Procédures judiciaires</li>
          <li>Honoraires d'expert</li>
        </ul>
      </div>
    </div>
  </div>

  <div class="page-section">
    <h3>Professions Concernées</h3>
    <div class="professions-grid">
      <div class="profession-item obligatoire">
        <div class="badge">OBLIGATOIRE</div>
        <i class="pi pi-check-circle"></i>
        <h4>Professions Réglementées</h4>
        <p>Médecins, avocats, experts-comptables, architectes, agents immobiliers, 
           auto-écoles, agences de voyage...</p>
      </div>

      <div class="profession-item recommandee">
        <div class="badge">RECOMMANDÉE</div>
        <i class="pi pi-star"></i>
        <h4>Artisans & BTP</h4>
        <p>Plombiers, électriciens, maçons, peintres, menuisiers, 
           couvreurs, carreleurs...</p>
      </div>

      <div class="profession-item recommandee">
        <div class="badge">RECOMMANDÉE</div>
        <i class="pi pi-desktop"></i>
        <h4>Services & Conseil</h4>
        <p>Consultants, formateurs, développeurs, graphistes, 
           community managers, coachs...</p>
      </div>

      <div class="profession-item recommandee">
        <div class="badge">RECOMMANDÉE</div>
        <i class="pi pi-shopping-cart"></i>
        <h4>Commerce & Services</h4>
        <p>Commerçants, restaurateurs, coiffeurs, esthéticiennes, 
           professionnels du bien-être...</p>
      </div>
    </div>
  </div>

  <div class="page-section">
    <h3>Cas Pratiques de Sinistres</h3>
    <div class="examples-list">
      <div class="example-item">
        <i class="pi pi-wrench"></i>
        <div class="content">
          <h4>Plombier - Dégât des eaux</h4>
          <p>Un plombier provoque une fuite d'eau chez un client, causant 15 000€ de dégâts. 
             La RC Pro prend en charge l'indemnisation et les frais de réparation.</p>
        </div>
      </div>

      <div class="example-item">
        <i class="pi pi-briefcase"></i>
        <div class="content">
          <h4>Consultant - Erreur de conseil</h4>
          <p>Un consultant donne un mauvais conseil stratégique causant 50 000€ de perte à son client. 
             La RC Pro couvre l'indemnisation et les frais de défense.</p>
        </div>
      </div>

      <div class="example-item">
        <i class="pi pi-building"></i>
        <div class="content">
          <h4>Architecte - Vice de construction</h4>
          <p>Une erreur de conception nécessite des travaux de reprise pour 80 000€. 
             La RC Pro décennale intervient pour couvrir les réparations.</p>
        </div>
      </div>

      <div class="example-item">
        <i class="pi pi-users"></i>
        <div class="content">
          <h4>Coach sportif - Accident client</h4>
          <p>Un client se blesse durant une séance et réclame 20 000€ de dommages et intérêts. 
             La RC Pro indemnise la victime et couvre les frais juridiques.</p>
        </div>
      </div>
    </div>
  </div>

  <div class="page-section info-box">
    <h3><i class="pi pi-info-circle"></i> Bon à Savoir</h3>
    <p>
      La RC Pro fonctionne en <span class="highlight">« réclamation faite »</span> (claims made) : 
      le contrat en vigueur au moment de la réclamation du tiers lésé vous couvre, même si les faits 
      sont antérieurs à la souscription.
    </p>
    <p>
      Pensez à vérifier la <span class="highlight">garantie rétroactivité</span> et la 
      <span class="highlight">garantie postériorité</span> pour une protection complète.
    </p>
  </div>

  <div class="page-section">
    <h3>Comment Choisir Votre RC Pro ?</h3>
    <ul>
      <li><strong>Définissez vos risques</strong> : analyse selon votre secteur d'activité</li>
      <li><strong>Vérifiez les plafonds</strong> : montants de garantie adaptés à vos risques</li>
      <li><strong>Lisez les exclusions</strong> : ce qui n'est pas couvert par le contrat</li>
      <li><strong>Comparez les franchises</strong> : montant restant à votre charge</li>
      <li><strong>Vérifiez la territorialité</strong> : France, Europe, Monde</li>
      <li><strong>Optez pour les garanties complémentaires</strong> : protection juridique, cyber-risques...</li>
    </ul>
  </div>

  <div class="page-section">
    <h3>Les Avantages de Passer par Brokins</h3>
    <ul>
      <li><strong>Analyse de risques</strong> : évaluation précise selon votre métier</li>
      <li><strong>Devis personnalisés</strong> : comparaison des meilleures offres</li>
      <li><strong>Négociation tarifaire</strong> : accès aux tarifs préférentiels</li>
      <li><strong>Accompagnement sinistre</strong> : assistance en cas de réclamation</li>
      <li><strong>Révision annuelle</strong> : adaptation aux évolutions de votre activité</li>
      <li><strong>Expertise métier</strong> : connaissance des spécificités de chaque profession</li>
    </ul>
  </div>

  <div class="page-section cta-box">
    <h3>Protégez Votre Activité Professionnelle</h3>
    <p>
      Obtenez un devis RC Pro adapté à votre métier et sécurisez votre exercice professionnel.
    </p>
    <button class="btn-cta" (click)="navigateToComparison()">
      Demander un devis RC Pro
    </button>
  </div>

</app-page-layout>
